/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Not_AvailableInputs */

const en_not_available = /** @type {(inputs: Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-`)
};

const es_not_available = /** @type {(inputs: Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-`)
};

/**
* | output |
* | --- |
* | "-" |
*
* @param {Not_AvailableInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const not_available = /** @type {((inputs?: Not_AvailableInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Not_AvailableInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_not_available(inputs)
	return es_not_available(inputs)
});